import React from 'react';
import { BodyParagraphData } from '@/types/writing';
import { SlashTriggerContext } from '@/types/slash-commands';
import { UnifiedParagraphSection } from './unified-paragraph-section';

interface DetailSectionProps {
  paragraphs: BodyParagraphData[];
  onParagraphChange: (idx: number, value: string) => void;
  onAdd: () => void;
  onRemove: (idx: number) => void;
  isSlashMenuOpen: boolean;
  handleSlashTrigger: (context: SlashTriggerContext) => void;
  handleSlashFilterUpdate: (filterText: string) => void;
  handleSlashClose: () => void;
  handleTextareaKeyDown: (
    event: React.KeyboardEvent<HTMLTextAreaElement>
  ) => void;
  textareaClassName?: string;
}

export function DetailSection({
  paragraphs,
  onParagraphChange,
  onAdd,
  onRemove,
  isSlashMenuOpen,
  handleSlashTrigger,
  handleSlashFilterUpdate,
  handleSlashClose,
  handleTextareaKeyDown,
  textareaClassName,
}: DetailSectionProps) {
  return (
    <UnifiedParagraphSection
      paragraphs={paragraphs}
      onParagraphChange={onParagraphChange}
      onAdd={onAdd}
      onRemove={onRemove}
      isSlashMenuOpen={isSlashMenuOpen}
      handleSlashTrigger={handleSlashTrigger}
      handleSlashFilterUpdate={handleSlashFilterUpdate}
      handleSlashClose={handleSlashClose}
      handleTextareaKeyDown={handleTextareaKeyDown}
      textareaClassName={textareaClassName}
      sectionType='detail'
      showTypeSelection={false}
      placeholderPrefix='Detail paragraph'
      addButtonTooltip='Add Detail Paragraph'
    />
  );
}
